// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-body[data-v-21130fc6]{padding:16px 16px 0}.btn-cancel[data-v-21130fc6]{display:inline-block}.volo-button-secondary.active[data-v-21130fc6]{border:1px solid #f57e20}.country-pick img[data-v-21130fc6]{width:25px;margin-right:5px}", ""]);
// Exports
module.exports = exports;
